"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfig = void 0;
var config_1 = require("./config");
Object.defineProperty(exports, "envConfig", { enumerable: true, get: function () { return config_1.envConfig; } });
